import { __decorate } from "tslib";
import { AccountModule } from '@blade-sxp/account/store/account';
import { Component, Vue, Watch } from 'vue-property-decorator';
import AvatarUploader from '@blade/common/components/avatar-uploader.vue';
import treeSelect from '@blade-sxp/account/components/tree-select.vue';
import { OrganizationModule } from '@blade-sxp/account/store/organization';
import { mapTree } from '@blade-sxp/account/utils/orgnization-map-tree';
import { RoleModule } from '@blade-sxp/account/store/role';
import { mapSelect } from '@blade-sxp/account/utils/map-tree';
import { dateFormat } from '@blade/common/utils/filters';
import { handleError } from '@blade/common/utils/handle-error';
import { mapTree as mapDevice } from './utils/map-tree';
import RoleSelect from './components/role-tree.vue';
import password from '@blade-sxp/account/lang/password';
import { validatePassword } from '@blade-sxp/account/utils/validate';
import EncryptInput from '@blade/common/components/encrypt-input.vue';
import InvisibleNumber from '@blade/common/components/invisible-number.vue';
const GUEST_ADMIN = 'GUEST_ADMIN';
let default_1 = class default_1 extends Vue {
    form = {
        user_name: '',
        real_name: '',
        role_ids: [],
        password: '',
        check_password: '',
        phone: '',
        enable_start_time: '',
        enable_end_time: '',
        avatar: '',
        email: '',
        valid: [],
        org_id: '',
        device_resources: [],
        radio: 1, // 1 true, 2 false
    };
    deviceTree = [];
    currRole = '';
    defaultExpandKeys = [];
    get accountRules() {
        // console.log('accountRules');
        return {
            org_id: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (!this.form.org_id) {
                            callback(new Error(this.$t('accountError').toString()));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            user_name: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (!this.form.user_name || this.form.user_name.length < 3) {
                            callback(new Error(this.$t('userNameError').toString()));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            real_name: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (!this.form.real_name) {
                            callback(new Error(this.$t('realNameError').toString()));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            role_ids: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        // console.log('value:', this.form.role_ids);
                        if (this.form.role_ids.length === 0) {
                            callback(new Error(this.$t('roleIdsError').toString()));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            password: [
                {
                    required: this.mode === 'CREATE',
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        const msg = validatePassword(value, this.form.user_name);
                        if (!value && this.mode === 'CREATE') {
                            callback(new Error(this.$t('reenterPasswordError').toString()));
                        }
                        else if (value && msg) {
                            callback(new Error(this.$t(msg).toString()));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            check_password: [
                {
                    required: this.mode === 'CREATE',
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (!value && this.mode === 'CREATE') {
                            callback(new Error(this.$t('reenterPasswordError').toString()));
                        }
                        else if (this.form.password && this.form.password !== value) {
                            callback(new Error(this.$t('reenterDiffError').toString()));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            phone: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error(this.$t('phoneNumberError').toString()));
                        }
                        else if (this.form.phone.length < 3) {
                            callback(new Error(this.$t('phoneLengthError').toString()));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            email: [
                {
                    required: true,
                    trigger: ['blur'],
                    validator: (rule, value, callback) => {
                        if (!this.form.email) {
                            callback(new Error(this.$t('emailError').toString()));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            valid: [
                {
                    required: true,
                    trigger: ['change'],
                    validator: (rule, value, callback) => {
                        if (value.length !== 2) {
                            callback(new Error(this.$t('dateRangeError').toString()));
                        }
                        else if (value.length !== 2) {
                            callback(new Error(this.$t('dateRangeError').toString()));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            device_resources: [
                {
                    required: true,
                    trigger: ['change'],
                    validator: (rule, value, callback) => {
                        if (this.deviceTree.length > 0 && this.form.device_resources.length <= 0) {
                            callback(new Error('no device selected'));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
            radio: [
                {
                    required: true,
                    trigger: ['change'],
                    validator: (rule, value, callback) => {
                        if (!this.form.radio) {
                            callback(new Error('no device selected'));
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
        };
    }
    get showDevice() {
        return this.deviceTree.length > 0 && this.currRole === GUEST_ADMIN;
    }
    title = '';
    avatar = '';
    treeData = [];
    roleSelect = [];
    mode = 'CREATE';
    id = '';
    visible1 = false;
    visible2 = false;
    // get name() {
    //   return UserModule.name
    // }
    // get roles() {
    //   return UserModule.roles
    // }
    async mounted() {
        const { meta } = this.$route;
        this.title = meta.page;
        await this.getOrganization();
        await this.getRoleDataSelect();
        if (meta.page === 'accountEdit') {
            console.log('meta:', meta.page);
            this.getData();
        }
        this.resetForm();
    }
    async getDevices() {
        try {
            const res = await AccountModule.getDevicesTree();
            console.log('res:', res);
            const mappedDevice = mapDevice(res.data?.tree ?? []);
            this.deviceTree = mappedDevice;
            console.log('deviceTree:', mappedDevice);
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    handleCheck() {
        const res = this.$refs['device-tree'].getCheckedNodes();
        // console.log("res:", res)
        const ids = res.map((item) => {
            return { resource_id: item.id, resource_type: item.nodeType === 'DEVICE' ? 'IOT_DEVICE' : 'IOT_DEVICE_GROUP' };
        });
        console.log('res:', ids);
        this.form.device_resources = ids;
    }
    async getData() {
        const { params } = this.$route;
        this.id = params.id;
        this.mode = 'EDIT';
        try {
            const res = await AccountModule.getUserDetail(this.id);
            console.log('params:', res);
            this.mapForm(res);
        }
        catch (e) {
            handleError(e);
        }
    }
    async mapForm(data) {
        const { avatar, enable_start_time, enable_days, org_member, org_name, role_names, state, user_id, enable_end_time, role_type, tree_nodes, face_access_status, ...rest } = data;
        this.form = {
            user_name: rest.user_name,
            real_name: rest.real_name,
            role_ids: rest.role_ids?.length > 0 ? rest.role_ids : [],
            phone: rest.phone.toString(),
            enable_start_time: '',
            enable_end_time: '',
            avatar: avatar,
            email: rest.email,
            valid: [new Date(enable_start_time), new Date(enable_end_time)],
            org_id: rest.org_id ?? '',
            password: rest.password,
            check_password: rest.check_password,
            permanent: rest.permanent || false,
            device_resources: [],
            radio: face_access_status ? 1 : 2,
        };
        this.avatar = avatar;
        this.$nextTick(() => {
            this.$refs['account-form']?.clearValidate();
        });
        this.currRole = role_type;
        if (role_type === GUEST_ADMIN) {
            await this.getDevices();
            const res = [];
            this.getSelectedIds(tree_nodes, res);
            this.defaultExpandKeys = res;
            console.log('curr tree:', res);
            this.$refs['device-tree'].setCheckedKeys(res);
        }
    }
    getSelectedIds(treeNodes, ids) {
        if (!treeNodes) {
            return [];
        }
        treeNodes.forEach(item => {
            // console.log("item:", item)
            if (item.selected) {
                ids.push(item.treeId);
            }
            if (item.children && item.children.length > 0) {
                this.getSelectedIds(item.children, ids);
            }
        });
    }
    async getOrganization() {
        try {
            const res = await OrganizationModule.getOrganizationTree();
            this.treeData = mapTree([res]);
        }
        catch (e) { }
    }
    async getRoleDataSelect() {
        try {
            const res = await RoleModule.getAllRoles();
            const mappedOrg = mapSelect(res);
            this.roleSelect = mappedOrg;
        }
        catch (e) { }
    }
    handleCancel() {
        this.$router.replace('/setting/account');
    }
    handleSubmit() {
        this.$refs['account-form'].validate((valid) => {
            console.log('form submit:', this.mode);
            if (valid) {
                if (this.mode === 'CREATE') {
                    this.createUser();
                }
                else {
                    this.updateUser();
                }
            }
            else {
                return false;
            }
        });
    }
    async createUser() {
        console.log('create');
        const mappedEdit = this.mapData();
        try {
            await AccountModule.createUser(mappedEdit);
            this.$elmessage.success(this.$t('successCreate').toString());
            this.$router.push('/setting/account');
        }
        catch (e) {
            this.$elmessage.error(e.message);
        }
    }
    async updateUser() {
        const mappedEdit = this.mapUpdate();
        try {
            await AccountModule.updateUserDetail(mappedEdit);
            this.$elmessage.success(this.$t('successUpdate').toString());
            this.$router.push('/setting/account');
        }
        catch (e) {
            handleError(e);
        }
    }
    handleAvatar($e) {
        this.avatar = $e;
    }
    mapData() {
        const { valid, enable_start_time, enable_end_time, radio, ...rest } = this.form;
        const start_time = dateFormat(new Date(valid[0]), 'YYYY-MM-DD HH:mm:ss') || '';
        const end_time = dateFormat(new Date(valid[1]), 'YYYY-MM-DD HH:mm:ss') || '';
        const res = {
            ...rest,
            enable_start_time: start_time,
            enable_end_time: end_time,
            avatar: this.avatar,
            face_access_status: radio === 1
        };
        return res;
    }
    mapUpdate() {
        const { valid, enable_start_time, enable_end_time, email, permanent, user_name, password, check_password, radio, ...rest } = this.form;
        const start_time = dateFormat(new Date(valid[0]), 'YYYY-MM-DD HH:mm:ss') || '';
        const end_time = dateFormat(new Date(valid[1]), 'YYYY-MM-DD HH:mm:ss') || '';
        const res = {
            ...rest,
            enable_start_time: start_time,
            enable_end_time: end_time,
            avatar: this.avatar,
            id: this.id,
            email: email,
            password: password,
            user_name: user_name,
            face_access_status: radio === 1
        };
        return res;
    }
    handleUpdateDep(data) {
        this.form.org_id = data.id;
    }
    handleUpdateRole($event) {
        this.form.role_ids = $event;
        const res = this.roleSelect.filter((item) => item.id === $event[0]);
        console.log('res:', res);
        this.currRole = res[0]?.type ?? '';
        if (res && res[0]?.type === GUEST_ADMIN) {
            this.getDevices();
        }
    }
    beforeDestroy() {
        this.resetForm();
    }
    resetForm() {
        this.$refs['account-form'].resetFields();
        this.form = {
            user_name: '',
            real_name: '',
            role_ids: [],
            password: '',
            check_password: '',
            phone: '',
            enable_start_time: '',
            enable_end_time: '',
            avatar: '',
            email: '',
            valid: [],
            org_id: '',
            device_resources: [],
            radio: 1
        };
        this.$nextTick(() => {
            this.$refs['account-form']?.clearValidate();
        });
    }
    handleVisible1() {
        this.visible1 = !this.visible1;
    }
    handleVisible2() {
        this.visible2 = !this.visible2;
    }
    onLocaleChange(newVal) {
        this.$refs['account-form']?.clearValidate();
        const { meta } = this.$route;
        this.title = meta.page;
        if (meta.page === 'accountEdit') {
            this.getData();
        }
    }
};
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "onLocaleChange", null);
default_1 = __decorate([
    Component({
        name: 'AccountEdit',
        components: { AvatarUploader, 'tree-select': treeSelect, RoleSelect, EncryptInput, InvisibleNumber },
        i18n: {
            messages: {
                'en-us': {
                    accountEdit: 'Edit',
                    accountCreate: 'Create',
                    startDate: 'Start Date',
                    endDate: 'End Date',
                    accountNumber: 'Account Name',
                    accountName: 'User Name',
                    accountRole: 'Role',
                    accountPassword: 'Password',
                    accountRePassword: 'Reenter Password',
                    phone: 'Phone Number',
                    validDate: 'Valid Date',
                    cancel: 'Cancel',
                    submit: 'Submit',
                    deviceAuthority: 'Authority device management:',
                    organization: 'Affiliated Department',
                    accountError: 'Please select department',
                    userNameError: 'Please input account name, the length of account name need to be at least 3',
                    realNameError: 'Please input real name',
                    roleIdsError: 'Please input role name',
                    passwordError: 'Please input password',
                    reenterPasswordError: 'Password is required',
                    reenterDiffError: 'Password is different',
                    phoneNumberError: 'Please input phone number',
                    phoneLengthError: 'The length of phone number should be at least 3 digits',
                    emailError: 'Please input email',
                    dateRangeError: 'Please input date range',
                    passwordValidation: 'Password should contain at least 9 characters with combination of three in uppercase letter, one lowercase letter, one special character and one digit',
                    successCreate: 'Successfully create user',
                    successUpdate: 'Successfully update user',
                    email: 'Email',
                    allowFace: 'Allow visit face images',
                    yes: 'yes(default)',
                    no: 'No',
                    picType: 'Image type includes: Monitor face images, Alert face images, Face snapshots, Pass images, Pass snapshots',
                    to: 'To'
                },
                zh: {
                    accountEdit: '编辑账号',
                    accountCreate: '新增账户',
                    startDate: '开始日期',
                    endDate: '结束日期',
                    accountNumber: '账户名',
                    accountName: '姓名',
                    accountRole: '角色',
                    accountPassword: '密码',
                    accountRePassword: '重输密码',
                    phone: '电话号码',
                    validDate: '有效期限',
                    cancel: '取消',
                    submit: '提交',
                    organization: '所属部门',
                    deviceAuthority: '通行设备权限：',
                    accountError: '请选择部门',
                    userNameError: '请输入用户名，名字最小长度为3',
                    realNameError: '请输入名字',
                    roleIdsError: '请输入角色名称',
                    passwordError: '请输入密码',
                    reenterPasswordError: '请填密码',
                    reenterDiffError: '两次密码不一致',
                    phoneNumberError: '请输入电话',
                    phoneLengthError: '号码长度至少3位',
                    emailError: '请输入邮箱',
                    dateRangeError: '请输入时间',
                    passwordValidation: '密码至少9位由大写字母，小写字母，特殊字符和数字至少三种组成',
                    successCreate: '成功创建用户',
                    successUpdate: '成功更新用户',
                    email: '邮箱',
                    allowFace: '允许访问人脸图片',
                    yes: '是（默认）',
                    no: '否',
                    picType: '图片类型包含：人脸布控底图，人脸布控告警图，人脸抓拍图，通行底图，通行抓拍图',
                    to: '至'
                },
            },
            sharedMessages: password
        },
    })
], default_1);
export default default_1;
